export default __webpack_public_path__ + "static/media/chica-head-mb@2x.b90d5224.png";